import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TokenStorageService } from 'src/app/services/token-storage-service/token-storage.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
})
export class DashboardComponent implements OnInit {
  isLoggedIn = false;
  user: any;

  constructor(
    private tokenStorageService: TokenStorageService,
    public router: Router
  ) {}

  isDashboardRoute(): boolean {
    return this.router.url === '/';
  }

  ngOnInit(): void {
    this.isLoggedIn = this.tokenStorageService.getToken() !== '';
    // if (this.isLoggedIn) {
    //   this.user = this.tokenStorageService.getUser();
    //   this.router.navigateByUrl('/');
    // }
  }
}
